module.exports = __webpack_public_path__ + "img/RedditIcon.84a04d19.png";